import { createFileRoute } from "@tanstack/react-router";
import Page from "./-page";

export const Route = createFileRoute(
  "/_private/_inventory-360/inventory/$inventoryId/lot/unassigned",
)({
  component: UnassignedLotRoute,
});

function UnassignedLotRoute() {
  const { inventoryId } = Route.useParams();
  return <Page inventoryId={inventoryId} />;
}
